import { Box, SimpleGrid } from "@chakra-ui/react";

import { homeShowcaseGames } from "@/data/games";
import { useI18n } from "@/i18n";
import { SectionHeading } from "@/shared/ui/SectionHeading";
import { GameCard } from "./GameCard";

export function GameGrid() {
  const { copy } = useI18n();

  return (
    <Box id="games" as="section" py={{ base: 12, md: 16 }}>
      <Box mb={8}>
        <SectionHeading eyebrow={copy.games.eyebrow} title={copy.games.title} />
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5}>
        {homeShowcaseGames.map((game) => (
          <GameCard game={game} key={game.id} />
        ))}
      </SimpleGrid>
    </Box>
  );
}
